// import { FFmpeg } from '@ffmpeg/ffmpeg'
// import { fetchFile, toBlobURL } from '@ffmpeg/util'
import { spawn, Pool, Worker } from 'threads'

const SUPPORTED_IMAGE_FORMATS = [
  { contentType: 'image/jpeg', type: 'image' },
  { contentType: 'image/webp', type: 'image' },
  { contentType: 'image/svg+xml', type: 'image' },
  { contentType: 'image/tiff', type: 'image' },
  { contentType: 'image/gif', type: 'image' },
  { contentType: 'image/png', type: 'image' },
  { contentType: 'image/bmp', type: 'image' },
  { contentType: 'img/png', type: 'image' },
  { contentType: 'image/avif', type: 'image' },
  { contentType: 'image/x-adobe-dng', type: 'image' },
  { contentType: 'image/dng', type: 'image' },
  { contentType: 'image/jpg', type: 'image' },
  { contentType: 'image/heic', type: 'image' }
]

const SUPPORTED_VIDEO_FORMATS = [
  { contentType: 'video/mp4', type: 'video' },
  { contentType: 'video/quicktime', type: 'video' },
  { contentType: 'video/x-m4v', type: 'video' },
  { contentType: 'video/mpeg', type: 'video' },
  { contentType: 'video/avi', type: 'video' },
  { contentType: 'video/ogg', type: 'video' },
  { contentType: 'video/3gpp', type: 'video' },
  { contentType: 'video/webm', type: 'video' },
  { contentType: 'video/x-flv', type: 'video' },
  { contentType: 'video/x-matroska', type: 'video' },
  { contentType: 'video/x-msvideo', type: 'video' },
  { contentType: 'video/x-ms-vob', type: 'video' },
  { contentType: 'video/x-ms-wmv', type: 'video' }
]

/* @ngInject */
function assetThumbnailGeneratorService () {
  const worker = new Worker(new URL('/app/core/workers/asset-thumbnail-generator.worker.js', import.meta.url))
  const pool = Pool(() => spawn(worker), navigator.hardwareConcurrency /* optional size */)

  const service = {
    generateThumbnailFromVideo,
    generateThumbnailFromImage
  }
  return service

  function generateThumbnailFromVideo (file, options = {}) {
    if (!file) return Promise.resolve(null)

    const isFileSupported = SUPPORTED_VIDEO_FORMATS.some((supportedVideoType) => supportedVideoType.contentType === file.type)

    if (!isFileSupported) {
      throw new Error('File not supported for local thumbnail generation')
    }

    return generateThumbnail(file, options)
  }

  /**
   * @description Generates thumbnail for a image
   * @param {File} file
   * @param {Object} options
   * @param {String[]} options.qualities {LOW, MID, HIGH}
   * @param {Boolean} options.webp Enable WEBP thumbnail generation
   * @param {Boolean} options.png Enable PNG thumbnail generation
   * @returns {Promise<File>}
   */
  function generateThumbnailFromImage (file, options = {}) {
    if (!file) return Promise.resolve(null)

    const isFileSupported = SUPPORTED_IMAGE_FORMATS.some((supportedImageType) => supportedImageType.contentType === file.type)

    if (!isFileSupported) {
      throw new Error('File not supported for local thumbnail generation')
    }

    return generateThumbnail(file, options)
  }

  function generateThumbnail (file, options = {}) {
    return new Promise((resolve, reject) => {
      // add item to asset-thumbnail-generator.worker.js queue
      const queuedTask = pool.queue((thumbnailGeneratorWorker) => {
        return thumbnailGeneratorWorker(file, {
          qualities: options.qualities,
          webp: options.webp,
          png: options.png
        })
      })
      queuedTask.then(resolve).catch((err) => {
        console.error(err)

        reject(err)
      })
    })
  }
}

export { assetThumbnailGeneratorService }
